import 'leaflet';
import './iframe';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#map') != null ) {
    let lat = document.querySelector('#map').dataset.lat;
    let long = document.querySelector('#map').dataset.long;

    console.log(lat);

    if (lat && long) {
      var map = L.map('map').setView([lat, long], 14);

      // old access token pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw
      // new access token pk.eyJ1Ijoid2VkaWEiLCJhIjoiY2xwMHhqanlzMGIzazJocXVvMnBzNDlwaSJ9.t6ktDEfgHxqhS3XLuRgUqg
      var tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2VkaWEiLCJhIjoiY2xwMHhqanlzMGIzazJocXVvMnBzNDlwaSJ9.t6ktDEfgHxqhS3XLuRgUqg', {
        maxZoom: 18,
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1
      }).addTo(map);

      var circle = L.circle([lat, long], {
        color: '#765e56',
        fillColor: '#765e56',
        fillOpacity: 0.5,
        radius: 500
      }).addTo(map);
    }
  }
}, {passive: true});
